import React from "react"

import Feature from "./Feature/feature"

import classes from "./features.module.scss"

const Features = () => {
  return (
    <section className={classes.Features} id="features">
      <Feature
        content="Análisis de sangre y de orina con entrega de resultados en el día."
        icon="syringe"
      />
      <Feature
        content="Más de 20 años al servicio de la comunidad de Gobernador Virasoro."
        icon="award"
      />
      <Feature
        content="Análisis de alta complejidad con derivación al laboratorio CEBAC de Posadas, Misiones."
        icon="flask"
      />
    </section>
  )
}

export default Features
